import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import MobileForm from './mobile-form';
import SMSKeyForm from '../shared/sms-key-form';
import PasswordForm from './password-form';
import Alert from '../shared/alert';
import {
  useCheckSMSKeyMutation,
  useForgetPasswordMutation,
  useResetPasswordMutation,
  useUser
} from '../../hooks/react-query/use-user';
import { useLoginMutation } from '../../hooks/react-query/use-auth';
import { DEFAULT_LOADER_CONTENT } from '../shared/loader';
import { getNextRedirectURL } from '../../utils/url';

function ForgetPassword() {
  const [step, setStep] = useState<number>(0);
  const [mobile, setMobile] = useState<string | null>(null);
  const [uid, setUID] = useState<string | null>(null);
  const [token, setToken] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const { isAuthenticated } = useUser();
  const { mutateAsync: loginUser } = useLoginMutation();
  const { mutateAsync: forgetPassword } = useForgetPasswordMutation();
  const { mutateAsync: checkSMSKey } = useCheckSMSKeyMutation();
  const { mutateAsync: resetPassword } = useResetPasswordMutation();

  if (isAuthenticated) return <Navigate replace to={getNextRedirectURL()} />;

  function renderForm(step: number) {
    if (step === MOBILE) {
      return (
        <MobileForm
          onSubmit={async function (mobile) {
            const { uid } = await forgetPassword({ mobile });
            setMobile(mobile);
            setUID(uid);
            setStep(SMS_KEY);
          }}
        />
      );
    }

    if (step === SMS_KEY) {
      if (!mobile || !uid) return null;

      return (
        <SMSKeyForm
          back
          mobile={mobile}
          onSubmit={async function (smsKey: string) {
            const { token } = await checkSMSKey({ uid, smsKey });
            setToken(token);
            setStep(PASSWORD);
          }}
          onResend={async function () {
            const { uid } = await forgetPassword({ mobile });
            setUID(uid);
          }}
          onBack={setStep.bind(null, MOBILE)}
          onError={setError}
        />
      );
    }

    if (step === PASSWORD) {
      if (!mobile || !uid || !token) return null;

      return (
        <PasswordForm
          onSubmit={async function (password: string) {
            await toast.promise(
              resetPassword(
                { uid, token, password },
                {
                  onSuccess: () =>
                    loginUser({ mobile, password }, { onSuccess: () => setStep(MOBILE) })
                }
              ),
              {
                loading: DEFAULT_LOADER_CONTENT,
                success: <b>رمز عبور شما با موفقیت تغییر کرد.</b>,
                error: <b className='text-red-500'>عدم موفقیت</b>
              }
            );
          }}
        />
      );
    }

    return null;
  }

  if (error) return <Alert content={error} className='mt-3 mb-5' />;
  return <div className='mx-auto w-full sm:w-4/5 lg:w-3/5'>{renderForm(step)}</div>;
}

const [MOBILE, SMS_KEY, PASSWORD] = [0, 1, 2];

export default ForgetPassword;
